import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getTaskCodes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/task-codes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching task codes:', error.response?.data || error);
    throw error;
  }
};

export const createTaskCode = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/task-codes`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating task code:', error.response?.data || error);
    throw error;
  }
};

export const updateTaskCode = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/task-codes/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating task code:', error.response?.data || error);
    throw error;
  }
};

export const deleteTaskCode = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/task-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting task code:', error.response?.data || error);
    throw error;
  }
};
